<template lang="html">
    <div id="page__customer-groups" class="center-panel">
        <md-content md-theme="white" v-bind:loading="progress">
            <user-menu></user-menu>
            <sort-table
                v-bind:columns="tableColumns" v-model="groups" @refresh="getCustomerGroups" link
                v-bind:per-page="perPage" v-bind:total="groupsAmount" ref="table" table-id="customer-groups"
                v-on:create="addGroup" tableHeight="calc(100% - 48px)"
            >
                <template slot="actions" slot-scope="scope">
                    <z-icon-button v-bind:icon="['fa', 'trash']" danger-light  rounded v-on:click.stop.prevent="onRemove(scope.item.id)"></z-icon-button>
                </template>
            </sort-table>
        </md-content>
    </div>
</template>
<script>
    import UserMenu    from './menu.vue';
    import SortTable   from "@/components/SortTable";
    import ZIconButton from '@/components/ZIconButton';
    export default {
        components: {UserMenu, SortTable, ZIconButton},
        data() {
            return {
                tableColumns: [
                    { label: 'ID', field: 'id', sortable: true },
                    { label: 'Символьный код', field: 'code', sortable: true },
                    { label: 'Название', field: 'name', sortable: true },
                    { label: '', field: 'actions' },
                ],
                title: 'Группы клиентов',
                perPage: 50
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['get-customers-groups-list'];
            },
            /**
             * Объект с флагами загрузки
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Список групп клиентов
             */
            groups() {
                return this.$store.state.customers.groups.map(group => {
                    group.routerLink = {name: 'CustomerGroup', params: {groupid: group.id}, query: this.$route.query};
                    return group;
                });
            },
            /**
             * Количество групп клиентов
             */
            groupsAmount() {
                return this.$store.state.customers.groups_amount;
            },
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                this.$store.commit('setTitle', 'Группы клиентов');
            },
            /**
             * Добавление группы
             */
            addGroup() {
                this.$router.push({ name: 'CustomerGroup', params: {groupid: 'new'}});
            },
            /**
             * Получение группы клиентов
             */
            getCustomerGroups(page, count, orderBy, orderType) {
                this.$store.commit('showProgressBar', 'get-customers-groups-list');
                this.$store.dispatch('customers/getCustomerGroups', {
                    page: page, order_by: orderBy, order_type: orderType, count: count, nocache: true
                }).finally(() => this.$store.commit('hideProgressBar', 'get-customers-groups-list'));
            },
            /**
             * Удаление группы клиентов
             */
            removeGroup(id) {
                if (!id) return;
                this.$store.commit('showProgressBar', 'get-customers-groups-list');
                this.$store.dispatch('customers/deleteCustomerGroup', id)
                    .then(() => this.$root.$emit('refresh-table', 'customer-groups'))
                    .finally(() => this.$store.commit('hideProgressBar', 'get-customers-groups-list'));
            },
            /**
             * Модальное окно с подтверждением удаления группы
             */
            onRemove(id) {
                this.$root.$emit(
                    'z-alert', 'Вы уверены в удалении группы', 'Действие необратимо!',
                    () => this.removeGroup(id)
                );
            }
        },
        watch: {
            '$route.name'(name) {
                if (name == 'CustomerGroups') this.init();
            },
        }
    }
</script>
<style lang="sass">
</style>



// WEBPACK FOOTER //
// Groups.vue?37b911aa